import { createSelector } from 'reselect';

export const selectDrawer = (state) => state.ui.drawer;
export const selectModal = (state) => state.ui.modal;
export const selectSnackbar = (state) => state.ui.snackbar;
export const selectBanners = (state) => state.ui.banners;
export const selectDeviceWidth = (state) => state.ui.deviceWidth;
export const selectDeviceHeight = (state) => state.ui.deviceHeight;
export const selectDeviceSize = (state) => state.ui.deviceSize;
export const selectLanguage = (state) => state.ui.language;
export const selectFullscreenButton = (state) => state.ui.fullscreenButton;
export const selectMobile = (state) => state.ui.mobile;
export const selectIsMobileMenuOpen = (state) => state.ui.isMobileMenuOpen;
export const selectIsVerticalScrollEnabled = (state) => state.ui.isVerticalScrollEnabled;
export const selectOriginURL = (state) => state.ui.originURL;
export const selectPostMessageTargetOrigin = (state) => state.ui.postMessageTargetOrigin;

export const selectIsMobile = createSelector(
  selectDeviceSize,
  (deviceSize) => deviceSize === 'xs' || deviceSize === 'sm',
);
